import { Injectable } from '@angular/core';
import { FilterAssistQuery } from '../../../interfaces/filter-assist-query';
import { ShipmentQuery } from '../../../models/shipment-query';
import { FilterAssist } from '../../../models/filter-assist';
import { ShipmentFilterService } from '../services/shipment-filter.service';
import { Observable, of } from 'rxjs';
import { FilterCategoryEnum } from '../../../enum/filter-category.enum';

@Injectable({
    providedIn: 'root'
})
export class ShipmentTextFilterService implements FilterAssistQuery<ShipmentQuery> {

    private SHIPMENT_SEARCH = 'SHIPMENT_SEARCH';

    constructor(private shipmentFilterService: ShipmentFilterService) {
        shipmentFilterService.registerFilters(this);
    }

    active(query: ShipmentQuery): Observable<FilterAssist[]> {
        if (query.filter) {
            return of([ {
                id: this.SHIPMENT_SEARCH,
                description: query.filter,
                parameter: query.filter,
                score: 0,
                category: FilterCategoryEnum.ANY
            } ]);
        }
        return of([]);
    }

    protected description(id: string, terms: string): string {
        return $localize`Search shipments for "${terms}"`;
    }

    apply(id: string, terms: string, query: ShipmentQuery): void {
        switch (id) {
            case this.SHIPMENT_SEARCH:
                query.filter = terms;
                break;
        }
    }

    ids(): string[] {
        return [ this.SHIPMENT_SEARCH ];
    }

    match(terms: string): Observable<FilterAssist[]> {
        return of([
            {
                id: this.SHIPMENT_SEARCH,
                description: $localize`Search shipments for "${terms}"`,
                parameter: terms,
                score: 10,
                category: FilterCategoryEnum.ANY
            }
        ]);
    }

    unapply(id: string, query: ShipmentQuery): void {
        query.filter = null;
    }
}
